import type { OptionsDocument, Pipeline } from 'paintscout'

export function getPipelines(args: { options: OptionsDocument }): Pipeline[] {
  const { options } = args
  const { pipelines } = options.options

  if (!pipelines) {
    return []
  }

  return pipelines.order
    .map((orderItem) => {
      const pipeline = pipelines.values[orderItem]
      if (!pipeline || pipeline?.deleted) {
        return null
      }
      return pipeline
    })
    .filter(Boolean)
}
